module.exports = __webpack_public_path__ + "static/media/front-end-mentor-challenge.ca846616.png";